import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AlertController} from '@ionic/angular';
import {IQApiService} from '../iqapi/iqapi.service';
import {UnlockObject} from '../../interfaces/interfaces.regisafe';
import {StorageService} from '../storage/storage.service';
import {ErrorHandlingService} from '../error-handling/error-handling.service';
import {ALERT_TXT} from '../../strings/language';


@Injectable()
export class CanDeactivateGuard implements CanDeactivate<any> {

	objId: string;
	osId: string;

	constructor(public alertCtrl: AlertController,
				private iqAPI: IQApiService,
				private storageService: StorageService,
				private errorHandling: ErrorHandlingService) {
	}

	async canDeactivate(component: any,
						route: ActivatedRouteSnapshot,
						state: RouterStateSnapshot) {

		// eslint-disable-next-line no-underscore-dangle
		this.objId = component.details[0]._ObjID;
		this.osId = component.orgastruktur;

		if (component.canDeactivate) {
			return true;
		} else {
			const conf = await this.confirm();
			if (conf.data.unlock && conf.role === 'unlock') {
				// Schriftstück entsperren
				// const options: UnlockObject = {
				// 	objID: this.objId,
				// 	osId: this.osId,
				// 	apiID: component.configuration.iqapiAppId,
				// 	sessionToken: component.storageService.getToken(),
				// };
				//
				// const unlock = await this.iqAPI.orgaManagerUnlockObject(options)
				// 	.toPromise()
				// 	.catch((e) => {
				// 		console.log('CanDeactivateGuard unlock: ', e);
				// 		this.errorHandling.handleError(e, 'CanDeactivateGuard');
				// 	});
				//
				// if (unlock.status === 1) {
				// 	this.storageService.removeLockedObject(this.objId);
				// 	component.objectLocked = false;
				// 	component.canDeactivate = true;
				// 	return true;
				// }

			} else if (!conf.data.unlock && conf.role === 'leave') {
				return true;
			} else if (!conf.data.unlock && conf.role === 'cancel') {
				return false;
			}
		}
	}

	async confirm(): Promise<any> {
		const alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00010,
			subHeader: ALERT_TXT.subHeader.str00010,
			buttons: [
				// {
				// 	text: ALERT_TXT.buttons.str00020,
				// 	role: 'unlock',
				// 	handler: () => ({unlock: true})
				// },
				{
					text: ALERT_TXT.buttons.str00030,
					role: 'leave',
					handler: () => ({unlock: false})
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel',
					handler: () => ({unlock: false})
				},]
		});

		await alert.present();
		return await alert.onDidDismiss().then(
			(data) => {
				return data;
			});
	}


}
